/**
 * Insights brand lift study (plans/insights-brand-lift-relaunch.md, build
 * design 2026-10-14).
 *
 * The auth host buckets each Insights reader per live study: `h` (holdout,
 * the campaign's line items exclude it) or `t` (test). The SDK caches that
 * assignment, sends the bucket to GAM as the study's key-value (`nbls`) on
 * every display request and Stories ad tag, and counts campaign exposure in
 * the shared ad runtime (lib/insights/study.js). Edit here and rebuild the SDK.
 */
module.exports = {
  STUDY_ASSIGNMENT_PATH: '/api/insights/study/v1/assignments',
  // Used when an assignment names no key-value of its own.
  STUDY_DEFAULT_TARGETING_KEY: 'nbls',
  // `milla_study:<brand>` = { v, fetchedAt, ttlMs, anonId, studies }.
  STUDY_ASSIGNMENT_STORAGE_PREFIX: 'milla_study:',
  STUDY_ASSIGNMENT_CACHE_VERSION: 1,
  // A fresh entry applies without a request; a stale one still applies at
  // once and is refreshed in the background. The response's ttlSeconds can
  // shorten this, never extend it.
  STUDY_ASSIGNMENT_TTL_MS: 6 * 60 * 60 * 1000,
  // Ad init waits at most this long for a first assignment. A late answer is
  // still stored and applies from the next pageview.
  STUDY_ASSIGNMENT_TIMEOUT_MS: 800,
  // Ad init waits for a first assignment only inside these windows: while a
  // study's line items can deliver. A holdout reader needs the key-value on
  // their first page only when that page can show a campaign ad. Outside the
  // windows the lookup still runs in the background (readiness week buckets
  // readers early), but the ads never wait for it. Add each study's GAM
  // flight with a day of margin before the start (clock skew, early lines).
  // Times are UTC; GAM's network day is America/Toronto.
  STUDY_AD_WAIT_WINDOWS: [
    // amazon-holiday-retail-q4-2026: GAM order 4210737777 delivers Nov 4
    // 00:00 – Dec 22 23:59 Toronto; the study runs through Dec 23.
    { startsAt: '2026-11-03T05:00:00Z', endsAt: '2026-12-24T05:00:00Z' }
  ],
  // `milla_study_exposure:<brand>:<studyKey>` = exposure counters.
  STUDY_EXPOSURE_STORAGE_PREFIX: 'milla_study_exposure:',
  // Survey selection waits at most this long for this page's ads to settle a
  // study reader's group.
  STUDY_GROUP_WAIT_MS: 3000,
  // Ad events seen before the first assignment arrives, kept in memory.
  STUDY_MAX_PENDING_EVENTS: 100
};
